<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: left; align-self: end;">Selected Portal: {{ portal?.name }}</h4>
    </div>
    <div class="col-sm-6">
        <h1 class="page-label">Portal Validation - Dashboard</h1>
    </div>
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: right; align-self: end;">Order Name: {{ state?.validation_attempt?.name }}</h4>
    </div>
</div>

<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <thead>
        <tr role="row" class="tablesorter-headerRow">
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">GTIN-14</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Description</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Expected Quantity</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Scanned Quantity</div>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr role="row" *ngFor="let lineItem of state?.validation_attempt?.line_items index as i;" [class.green-highlight]="isSuccessRow(lineItem)" [class.red-highlight]="isErrorRow(lineItem)" [class.yellow-highlight]="isPartialRow(lineItem)" [class.gray-highlight]="isUnknownRow(lineItem)">
            <td>
                {{ lineItem?.gtin14 }}
            </td>
            <td>
                {{ lineItem?.description }}
            </td>
            <td>
                {{ lineItem?.expected_quantity }}
            </td>
            <td>
                {{ lineItem?.current_quantity }}
            </td>
        </tr>
    </tbody>
</table>

<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onStartReaderClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Start Reader</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onStopReaderClicked()" [disabled]="!isReaderStarted() || isActionBeingPerformed">Stop Reader</button>
    </div>
    <div class="col-sm-6">

    </div>
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onClearOrderClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Clear Order</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onProcessClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Process Order</button>
    </div>
</div>

<div class="print-container">
    <h1 class="page-label">&nbsp;</h1>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
